import { useExtendWithSubnetworks, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_RISK_ZONE } from "../../../../common/constants/modules"

import { riskZonesQueryKeys } from "./queryKeys"
import { useRiskZonesQuery } from "./useRiskZonesQueries"

export function useRiskZonesTraffic(params = {}, config = {}) {
    const url = "risk_zone_clusters/stats/vehicles/"
    const { enabled = true } = config
    const { selectedNetwork } = useNetworksStateContext()
    const parameters = useExtendWithSubnetworks(params, API_MODULE_RISK_ZONE)

    return useRiskZonesQuery(
        url,
        riskZonesQueryKeys.vehicleStats(parameters),
        { ...parameters, project: selectedNetwork?.slug },
        {
            ...config,
            enabled: !!selectedNetwork?.slug && enabled,
        },
    )
}